import * as React from 'react'
import { useSelector } from 'react-redux'
import { Formik } from 'formik'
import {
  selectOverdueNextActionDates,
  flipCard,
  setAssigneeIds,
  setSalesTeamsIds,
} from '@user/store/dashboard/widgets/overdueNextActionDates/slice'
import { useGetSalesTeamListOnMount } from '@user/store/salesTeam/hooks'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { SettingsForm } from './SettingsForm'
import { useHandleSubmit, useInitData } from '../../hooks'

export function ContentBack() {
  const teamStatus = useGetSalesTeamListOnMount()
  const widgetData = useSelector(selectOverdueNextActionDates)
  const { handleOverdueNextActionDatesSubmit } = useHandleSubmit({
    flipCard,
    setAssigneeIds,
    setSalesTeamsIds,
  })
  const { initSalesTeams, initOwnersIds, initSalesTeamsIds } =
    useInitData(widgetData)

  return (
    <>
      {teamStatus === 'pending' && (
        <Box p={2} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      )}

      {teamStatus === 'fail' && <Alert>Failed to load widget settings.</Alert>}

      {teamStatus === 'success' && (
        <Formik
          initialValues={{
            assigneeIds: initOwnersIds,
            salesTeamIds: initSalesTeamsIds,
          }}
          onSubmit={handleOverdueNextActionDatesSubmit}
        >
          <SettingsForm
            salesTeams={initSalesTeams}
            assigneeIds={widgetData.assigneeIds}
            initData={{
              assigneeIds: initOwnersIds,
              salesTeamIds: initSalesTeamsIds,
            }}
          />
        </Formik>
      )}
    </>
  )
}
